import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import "./sidebar.scss";

const Sidebar = ({ favorites }) => {
  const numFavorites =
    favorites.length === 0 ? "Favorites" : `Favorites(${favorites.length})`;
  return (
    <div className="sidebar">
      <NavLink className="sidebar-link" to="/" activeClassName="active" exact>
        Popular
      </NavLink>
      <NavLink className="sidebar-link" to="/upcoming" activeClassName="active">
        Upcoming
      </NavLink>
      <NavLink className="sidebar-link" to="/playing" activeClassName="active">
        Playing
      </NavLink>
      <NavLink
        className="sidebar-link"
        to="/favorites"
        activeClassName="active"
      >
        {numFavorites}
      </NavLink>
    </div>
  );
};

const mapState = state => {
  return {
    favorites: state.favorites.favorites
  };
};

export default connect(mapState)(Sidebar);
